export function formatMinutesFromMs(ms: number): string {
    if (!Number.isFinite(ms) || ms <= 0) return "0m";
    return `${Math.round(ms / 60000)}m`;
}

export function formatCompactNumber(value: number): string {
    return new Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: value >= 100 ? 0 : 1,
    }).format(value);
}

export function formatPercent(value: number, digits: number = 1): string {
    if (!Number.isFinite(value)) return "-";
    return `${value.toFixed(digits)}%`;
}

export function formatCount(value: number): string {
    return new Intl.NumberFormat("en-US").format(value);
}

export function formatSummaryStat(label: string, value: number): string {
    if (!Number.isFinite(value)) return `${label}: -`;
    if (label.toLowerCase().includes("p")) return `${label}: ${Math.round(value)}`;
    return `${label}: ${Math.round(value * 10) / 10}`;
}

export function percentile(values: number[], p: number): number {
    if (!values.length) return 0;
    const sorted = [...values].sort((a, b) => a - b);
    const idx = Math.min(sorted.length - 1, Math.max(0, Math.floor((p / 100) * (sorted.length - 1))));
    return sorted[idx];
}

export function mean(values: number[]): number {
    if (!values.length) return 0;
    return values.reduce((sum, value) => sum + value, 0) / values.length;
}
